import * as React from 'react';

import AcceptB2B from './Templates/acceptB2BTemplate';
import ActionTemplate from './Templates/actionTemplate';
import ActivityTemplate from './Templates/activityTemplate';
import BlockedTemplate from './Templates/blockedTemplate';
import ChangedRegisterEmail from './Templates/changedRegisterEmail';
import OrganizationTemplate from './Templates/organizationTemplate';
import RejectB2B from './Templates/rejectB2BTemplate';
import RespondB2B from './Templates/respondB2BTemplate';
import SendB2B from './Templates/sendB2BTemplate';
import TerminateB2B from './Templates/terminateB2BTemplate';
import UserTemplate from './Templates/user';
import WorkkardTemplate from './Templates/workkardTemplate';
import TodoTemplate from './Templates/todoTemplate';
import BulkActionTemplate from './Templates/bulkAction';
import MiscellaneousTemplate from './Templates/miscelleneousTemplates';
import {NotificationTemplateType} from "./constants.js";

export default class NotificationCell extends React.Component { 

    constructor (props){
        super(props)
        this.renderTemplate = this.renderTemplate.bind(this);
    }

    renderTemplate(data,extraData) {
         switch (data.UpdateType){
            case NotificationTemplateType.OrganizationSignup:
                return <OrganizationTemplate type="Signup" data={data} 
                        handleCardClick={this.props.onCellClick}
                        extraData={extraData} />;
            case NotificationTemplateType.OrganinzationToolTipTemplate:
                return <OrganizationTemplate type="ToolTip" data={data}  
                        handleCardClick={this.props.onCellClick}
                        extraData={extraData} />;
            case NotificationTemplateType.ActivityUpdated:
                return <ActivityTemplate type="Update"  data={data} 
                        handleCardClick={this.props.onCellClick}
                        extraData={extraData} />;
            case NotificationTemplateType.WorkkardUpdated:
                return <WorkkardTemplate type="Update" data={data} 
                        handleCardClick={this.props.onCellClick}
                        extraData={extraData} />;
            case NotificationTemplateType.UserSignup:
                return <UserTemplate  data={data} type="Signup" 
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.UserToolTipTemplate:
                return <UserTemplate  data={data} type="ToolTip" 
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.AcceptUser:
                return <UserTemplate  data={data} type="AcceptUser" 
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.RejectUser:
                return <UserTemplate  data={data} type="RejectUser"  
                        handleCardClick={this.props.onCellClick}
                        extraData={extraData} />;
            case NotificationTemplateType.BlockRuleUser:
                return <UserTemplate  data={data} type="BlockRuleUser"  
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.SendB2BRequest:
                return <SendB2B type="Request" data={data}  handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.RespondB2B:
                return <RespondB2B type="RespondB2B" data={data}  
                        handleCardClick={this.props.onCellClick}
                        extraData={extraData} />;
            case NotificationTemplateType.RespondB2BSender:
                return <RespondB2B type="RespondB2BSender" data={data}  
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.SendB2BContract:
                return <SendB2B type="Contract" data={data}
                        handleCardClick={this.props.onCellClick}
                        extraData={extraData} />;
            case NotificationTemplateType.SendB2BContractSender:
                return <SendB2B type="ContractSender" data={data} 
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.AcceptB2BContract:
                return <AcceptB2B type="Contract" data={data}  
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.AcceptB2BContractSender:
                return <AcceptB2B type="ContractSender" data={data}  
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.RejectB2BContract:
                return <RejectB2B type="Contract" data={data}  
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.RejectB2BContractSender:
                return <RejectB2B type="ContractSender" data={data}  
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.RejectB2BVersion:
                return <RejectB2B type="Version" data={data}  
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.AcceptB2BVersion:
                return <AcceptB2B type="Version" data={data}  
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.RejectB2BVersionSender:
                return <RejectB2B type="VersionSender" data={data}  
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.AcceptB2BVersionSender:
                return <AcceptB2B type="VersionSender" data={data}  
                        handleCardClick={this.props.onCellClick}
                        extraData={extraData} />;
            case NotificationTemplateType.TerminateB2BContract:
                return <TerminateB2B type="Contract" data={data}  
                        handleCardClick={this.props.onCellClick}
                        extraData={extraData} />;
            case NotificationTemplateType.TerminateB2BContractSender:
                return <TerminateB2B type="ContractSender" data={data}  
                        handleCardClick={this.props.onCellClick}
                        extraData={extraData} />;
            case NotificationTemplateType.SendB2BVersion:
                return <SendB2B type="Version" data={data}  
                        handleCardClick={this.props.onCellClick}
                        extraData={extraData} />;
            case NotificationTemplateType.SendB2BVersionSender:
                return <SendB2B type="VersionSender" data={data}  
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.BlockedActivityOwner:
                return <BlockedTemplate type="ActivityOwner" data={data}   
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.BlockedWKSponsor:
                return <BlockedTemplate type="WorkkardSponsor" data={data}   
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.BlockedOwnerSponsor:
                return <BlockedTemplate type="OwnerSponsor" data={data}   
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.ChangedRegisterEmail:
                return <ChangedRegisterEmail type="Contract" data={data}   
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.RejectActivity:
                return <ActivityTemplate type="Reject" data={data}   
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.AcceptActivity:
                return <ActivityTemplate type="Accept" data={data}   
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.ActivityProgressIncrease:
                return <ActivityTemplate type="ProgressIncrease" data={data}   
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.ActivityInProgressDecrease:
                return <ActivityTemplate type="InProgressDecrease" data={data}   
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.ActivityComplete:
                return <ActivityTemplate type="Complete" data={data}   
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.ActivityClose:
                return <ActivityTemplate type="Close" data={data}   
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.NewOwnerActivity:
                return <ActionTemplate type="NewOwnerActivity" data={data}   
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.YouAreNewOwnerActivity:
                return <ActionTemplate type="YouAreNewOwnerActivity" data={data}   
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.YouAreOwnerActivity:
                return <ActionTemplate type="YouAreOwnerActivity" data={data}   
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.UserSponsorWorkkard:
                return <ActionTemplate type="UserSponsorWorkkard" data={data}   
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.YouAreSponsorWorkkard:
                return <ActionTemplate type="YouAreSponsorWorkkard" data={data}   
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.CreatorAddedSponsor:
                return <ActionTemplate type="CreatorAddedSponsor" data={data}   
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.ActivityClosedMidterm:
                return <ActivityTemplate type="ClosedMidterm" data={data}   
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.ActivityReopened:
                return <ActivityTemplate type="Reopened" data={data}   
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.ActivityAssignedToOrg:
                return <ActionTemplate type="ActivityAssignedToOrg" data={data}   
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.ActivityReAssignedToOrg:
                return <ActionTemplate type="ActivityReAssignedToOrg" data={data}   
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.ActivityAssignedToUser:
                return <ActionTemplate type="ActivityAssignedToUser" data={data}   
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.ActivityAssignedToYou:
                return <ActionTemplate type="ActivityAssignedToYou" data={data}   
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.ActivityReassignedClose:
                return <ActionTemplate type="ActivityReassignedClose" data={data}   
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.ActivityReassignedToUser:
                return <ActionTemplate type="ActivityReassignedToUser" data={data}   
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.ActivityReassignedToYou:
                return <ActionTemplate type="ActivityReassignedToYou" data={data}   
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.ActivityNoteAdded:
                return <ActivityTemplate type="NoteAdded" data={data}   
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.ActivityNoteWithFileOnlyAdded:
                return <ActivityTemplate type="NoteWithFileOnlyAdded" data={data}   
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.ActivityNotePublished:
                return <ActivityTemplate type="NotePublished" data={data}   
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.PrivateActivityNoteAdded:
                return <ActivityTemplate type="PrivateActivityNoteAdded" data={data}   
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.PrivateActivityNotePublished:
                return <ActivityTemplate type="PrivateActivityNotePublished" data={data}   
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.PrivateActivityNoteWithFileOnlyPublished:
                return <ActivityTemplate type="PrivateActivityNoteWithFileOnlyPublished" data={data}   
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.PersonalActivityNotePrivatePublished:
                return <ActivityTemplate type="PersonalActivityNotePrivatePublished" data={data}   
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.PersonalActivityNoteWithFileOnlyPrivatePublished:
                return <ActivityTemplate type="PersonalActivityNoteWithFileOnlyPrivatePublished" data={data}   
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.PersonalActivityNotePublicPublished:
                return <ActivityTemplate type="PersonalActivityNotePublicPublished" data={data}   
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.PersonalActivityNoteWithFileOnlyPublicPublished:
                return <ActivityTemplate type="PersonalActivityNoteWithFileOnlyPublicPublished" data={data}   
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.ActivityWatcher:
                return <ActivityTemplate type="Watcher" data={data}   
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.WorkkardNoteAdded:
                return <WorkkardTemplate type="NoteAdded" data={data}   
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.WorkkardNoteWithFileOnlyAdded:
                return <WorkkardTemplate type="NoteWithFileOnlyAdded" data={data}   
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.WorkkardNotePublished:
                return <WorkkardTemplate type="NotePublished" data={data}   
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.PrivateWorkkardNoteAdded:
                return <WorkkardTemplate type="PrivateWorkkardNoteAdded" data={data}   
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.PrivateWorkkardNoteWithFileOnlyAdded:
                return <WorkkardTemplate type="PrivateWorkkardNoteWithFileOnlyAdded" data={data}   
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.PrivateWorkkardNotePublished:
                return <WorkkardTemplate type="PrivateWorkkardNotePublished" data={data}   
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.PrivateWorkkardNoteWithFileOnlyPublished:
                return <WorkkardTemplate type="PrivateWorkkardNoteWithFileOnlyPublished" data={data}   
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.WorkkardGroup:
                return <WorkkardTemplate type="WorkkardGroup" data={data}   
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.PersonalWorkkardNotePrivatePublished:
                return <WorkkardTemplate type="PersonalWorkkardNotePrivatePublished" data={data}   
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.PersonalWorkkardNoteWithFileOnlyPrivatePublished:
                return <WorkkardTemplate type="PersonalWorkkardNoteWithFileOnlyPrivatePublished" data={data}   
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.PersonalWorkkardNotePublicPublished:
                return <WorkkardTemplate type="PersonalWorkkardNotePublicPublished" data={data}   
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.PersonalWorkkardNoteWithFileOnlyPublicPublished:
                return <WorkkardTemplate type="PersonalWorkkardNoteWithFileOnlyPublicPublished" data={data}  
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.WorkkardWatcher:
                return <WorkkardTemplate type="Watcher" data={data}  
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.TodoReopen:
                return <TodoTemplate type="Reopen" data={data}  
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.TodoCompleted:
                return <TodoTemplate type="Completed" data={data}  
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.TodoDeleted:
                return <TodoTemplate type="Deleted" data={data}  
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.TodoEdited:
                return <TodoTemplate type="Edited" data={data}  
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.TodoAssigned:
                return <TodoTemplate type="Assigned" data={data}  
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.TodoReAssigned:
                return <TodoTemplate type="ReAssigned" data={data}  
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.TodoReminder:
                return <TodoTemplate type="Reminder" data={data}  
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.BulkOwnerChange:
                return <BulkActionTemplate type="BulkOwnerChange" data={data}  
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.BulkViewActivityOwnerChange:
                return <BulkActionTemplate type="BulkViewActivityOwnerChange" data={data}  
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.BulkViewActivityNewOwner:
                return <BulkActionTemplate type="BulkViewActivityNewOwner" data={data}  
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.BulkAcceptActivity:
                return <BulkActionTemplate type="BulkAcceptActivity" data={data}  
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.BulkRejectActivity:
                return <BulkActionTemplate type="BulkRejectActivity" data={data}  
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.BulkViewChangeActivityDueDate:
                return <BulkActionTemplate type="BulkViewChangeActivityDueDate" data={data}  
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.BulkWorkkardOwnerChange:
                return <BulkActionTemplate type="BulkWorkkardOwnerChange" data={data}  
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.BulkWorkkardOwnerChangeToYou:
                return <BulkActionTemplate type="BulkWorkkardOwnerChangeToYou" data={data}  
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.BulkViewCloseActivity:
                return <BulkActionTemplate type="BulkViewCloseActivity" data={data}  
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.BulkAssigneeChange:
                return <BulkActionTemplate type="BulkAssigneeChange" data={data}  
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.bulkactivityownerchange:
                return <BulkActionTemplate type="bulkactivityownerchange" data={data}  
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.BulkDiaryEdited:
                return <BulkActionTemplate type="BulkDiaryEdited" data={data}  
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.BulkDiaryCancelled:
                return <BulkActionTemplate type="BulkDiaryCancelled" data={data}  
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.BulkViewActivityReassignedToUser:
                return <BulkActionTemplate type="BulkViewActivityReassignedToUser" data={data}  
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.BulkViewActivityReassignedToOrg:
                return <BulkActionTemplate type="BulkViewActivityReassignedToOrg" data={data}  
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.BulkViewActivityReassignedToYou:
                return <BulkActionTemplate type="BulkViewActivityReassignedToYou" data={data}  
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.BulkViewActivityReassignedClosed:
                return <BulkActionTemplate type="BulkViewActivityReassignedClosed" data={data}  
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.BulkViewActivityAssignedToOrg:
                return <BulkActionTemplate type="BulkViewActivityAssignedToOrg" data={data}  
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.BulkViewActivityCompleted:
                return <BulkActionTemplate type="BulkViewActivityCompleted" data={data}  
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.BulkViewCompleteDiary:
                return <BulkActionTemplate type="BulkViewCompleteDiary" data={data}  
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.BulkDiaryAssigned:
                return <BulkActionTemplate type="BulkDiaryAssigned" data={data}  
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.BulkDiaryReAssigned:
                return <BulkActionTemplate type="BulkDiaryReAssigned" data={data}  
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.TimeFrameUpdated:
                return <MiscellaneousTemplate type="TimeFrameUpdated" data={data}  
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.RequestToJoinOrg:
                return <MiscellaneousTemplate type="RequestToJoinOrg" data={data}  
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.GrantAccess:
                return <MiscellaneousTemplate type="GrantAccess" data={data}  
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.ShareWorkkards:
                return <MiscellaneousTemplate type="ShareWorkkards" data={data}  
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.FeatureUpdate:
                return <MiscellaneousTemplate type="FeatureUpdate" data={data}  
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.WorkloadShift:
                return <MiscellaneousTemplate type="WorkloadShift" data={data}  
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.DeAssociateB2B:
                return <MiscellaneousTemplate type="DeAssociateB2B" data={data}  
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
            case NotificationTemplateType.RuleException:
                return <MiscellaneousTemplate type="RuleException" data={data}  
                        handleCardClick={this.props.onCellClick} 
                        extraData={extraData} />;
           
            default:
                return null;
        }
    }
    render(){
        const {data,extraData} = this.props;
       
        return (
            this.renderTemplate(data,extraData)
        );
    }
}